<mat-form-field appearance="outline">
  <mat-label>Tipo de GPS<span class="asterisk" *ngIf="utils.isRequiredField(gpsControl)">*</span></mat-label>
  <input type="text" #inputAutoComplete matInput [formControl]="gpsControl" [matAutocomplete]="auto">
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectGps()">
    <mat-option *ngFor="let type of listGeneralGpsType | async" [value]="type.name">
      <span class="d-flex align-items-center">
        <img *ngIf="getGpsImageInfo(type.name) as imageInfo" [src]="imageInfo.src" [alt]="imageInfo.alt"
          class="gps-logo" />
        <span>{{type.name}}</span>
        <span *ngIf="getGpsIntegrationStatus(type.name).isInProvider"
          [class]="'mr-2 ' + getIntegrationStatusColorClass(type.name)">
          <span *ngIf="getGpsIntegrationStatus(type.name).integrationStatus === 'complete'" class="integration-label">
            Con integración</span>
          <span *ngIf="getGpsIntegrationStatus(type.name).integrationStatus === 'pending'" class="integration-label">
            Integración pendiente</span>
        </span>
      </span>
    </mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="gpsControl?.errors?.required">
    {{ utils.giveMessageError('AT_LEAST_ONE_OPTION') }}
  </mat-error>
  <mat-error *ngIf="gpsControl?.errors?.pattern">
    {{ utils.giveMessageError('INCORRECT_FORMAT', 'tipo de gps') }}
  </mat-error>
  <mat-hint *ngIf="options?.hint && !inputFormControl?.value" class="color-secondary-dark text-bold">
    {{ options?.hint }}
  </mat-hint>
</mat-form-field>